export default __webpack_public_path__ + "static/media/B241.c0aef5bf.png";